module.exports = __webpack_public_path__ + "static/media/bg_confetti_big.3988d74d.png";